<template>
  <div>
    <div>
      <div class="ts-flex ts-justify-end ts-space-x-3">
        <ts-button
          color="primary"
          :waiting="exporting"
          @click.prevent="onExportExcel"
        >
          <i class="fas fa-file-excel"></i>
        </ts-button>
        <!-- <a-select
            v-model="location"
            style="width: 250px"
            showSearch
            mode="multiple"
            :placeholder="$t('location')"
            :maxTagTextLength="17"
            :maxTagCount="1"
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="fetchData()"
          >
            <a-select-option
              v-for="(l, index) in locations"
              :key="index"
              :value="l.location_id"
            >
              {{ l.location_name_en }}
            </a-select-option>
          </a-select> -->
        <ts-input
          v-model="search"
          :placeholder="$t('productCost.pSearch')"
          style="width: 250px"
          class="inline-block"
        />
      </div>
    </div>
    <ts-table
      :columns="columns"
      :records="sparePartResources"
      :loading="loading"
      class="mt-4"
    >
      <template v-slot="{ record }">
        <!-- <td>{{ record.location_name_en }}</td> -->
        <td>{{ record.barcode }}</td>
        <td>{{ record.product_name_en }}</td>
        <td>{{ record.uom_name_en }}</td>
        <td class="ts-text-center">{{ record.product_grade }}</td>
        <td class="ts-text-right">{{ $currencyFormat(record.cost) }}</td>
        <td class="ts-text-right">{{ $currencyFormat(record.sale_price) }}</td>
      </template>
    </ts-table>
    <div class="d-flex justify-content-end p-15">
      <ts-pagination
        v-model="sparePartPagination"
        @navigate="fetchData"
      ></ts-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce, trim } from 'lodash'
import * as FileDownload from 'downloadjs'
export default {
  name: 'sparePartTableList',
  data () {
    return {
      loading: false,
      exporting: false,
      locations: []
    }
  },
  computed: {
    ...mapState('product/cost', ['sparePartPagination', 'sparePartResources']),
    search: {
      get () {
        return this.$store.state.product.cost.spare_search
      },
      set (newValue) {
        this.$store.commit('product/cost/SET_SEARCH_SPARE', newValue)
        this.$store.commit('product/cost/RESET_CURRENT_PAGE')
      }
    },
    // location: {
    //   get() {
    //     return this.$store.state.product.cost.spare_list_location
    //   },
    //   set(newValue) {
    //     this.$store.commit('product/cost/SET_SPARE_LIST_LOCATION', newValue)
    //   }
    // },
    columns () {
      return [
        // { name: this.$t('productCost.warehouse') },
        { name: this.$t('productCost.barcode') },
        { name: this.$t('productCost.productName') },
        { name: this.$t('productCost.uom') },
        { name: this.$t('productCost.grade'), style: 'text-align:center' },
        { name: this.$t('productCost.oriCost'), style: 'text-align:right' },
        { name: this.$t('productCost.price'), style: 'text-align:right' }
      ]
    }
  },
  created () {
    this.fetchData()
    // this.fetchLocation()
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('product/cost/fetchSparePart', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    // async fetchLocation() {
    //   this.loading = true
    //   let response = await this.$store.dispatch('product/cost/getFormModel', {
    //     fnName: 'warehouseAssign'
    //   })

    //   this.locations = response.data.warehouseAssign
    //   this.loading = false
    // },
    onExportExcel () {
      this.exporting = true
      this.$store
        .dispatch('product/cost/sparePartToExcel')
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          // this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500)
  }
}
</script>
